/**
 * Consentimiento de analítica (PostHog) del sitio público de Pizas (paquete legal v2026-10-09, doc. 04).
 * - Por defecto NO hay consentimiento: sin elección guardada no se carga PostHog ni se envía nada.
 * - La elección se guarda en localStorage (`pizas_analytics_consent`) con fecha y versión; caduca a los 12 meses.
 * - Subir CONSENT_VERSION vuelve a preguntar a todos.
 */
export const CONSENT_STORAGE_KEY = 'pizas_analytics_consent';
export const CONSENT_VERSION = 1;
export const CONSENT_GRANTED = 'granted';
export const CONSENT_DENIED = 'denied';
export const CONSENT_MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000;

const CHANGE_EVENT = 'pizas:analytics-consent-change';
const OPEN_EVENT = 'pizas:open-cookie-preferences';

/** 'granted' | 'denied' | null (sin elección, de otra versión o de hace más de 12 meses). */
export function getAnalyticsConsent() {
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || data.version !== CONSENT_VERSION) return null;
    const at = Date.parse(data.date || '');
    if (!Number.isFinite(at) || Date.now() - at > CONSENT_MAX_AGE_MS) return null;
    return data.value === CONSENT_GRANTED || data.value === CONSENT_DENIED ? data.value : null;
  } catch (e) {
    return null;
  }
}

export function hasAnalyticsConsent() {
  return getAnalyticsConsent() === CONSENT_GRANTED;
}

export function setAnalyticsConsent(value) {
  const v = value === CONSENT_GRANTED ? CONSENT_GRANTED : CONSENT_DENIED;
  try {
    window.localStorage.setItem(
      CONSENT_STORAGE_KEY,
      JSON.stringify({ value: v, version: CONSENT_VERSION, date: new Date().toISOString() }),
    );
  } catch (e) {
    /* sin localStorage: la elección vale solo para esta visita */
  }
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: v }));
  return v;
}

export function onAnalyticsConsentChange(handler) {
  const fn = (e) => handler(e.detail);
  window.addEventListener(CHANGE_EVENT, fn);
  return () => window.removeEventListener(CHANGE_EVENT, fn);
}

/** Reabre el aviso de cookies (enlace «Preferencias de cookies» del pie y botón de /cookies). */
export function openCookiePreferences() {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}

export function onOpenCookiePreferences(handler) {
  window.addEventListener(OPEN_EVENT, handler);
  return () => window.removeEventListener(OPEN_EVENT, handler);
}
